<template>
  <layout name="LayoutDefault">
    <div class="About">
      <!-- Page Content -->
      <div class="container contents">
        <!-- Page Features -->
        <div class="pt-0 pt-md-3">
          <div class="row ">
            <div class="col-lg-3 col-md-4 col-sm-3 text-sm-left text-center">
              <div class="item-image text-center img-zoom-container_ position-relative mb-3" v-if="product[0].image">
                <div v-if="product[0].pdf" class="text-theme font-weight-bold mb-2">একটু পড়ে দেখতে নিচের ছবিতে ক্লিক করুন <i class="fa fa-arrow-down"></i></div>
                
                <a title="একটু পড়ে দেখুন" v-if="product[0].pdf" @click="readPdf(product[0].pdf)" href="javascript:;">
                  <img :src="`${IMAGEURL}${product[0].image}`" :srcset="`${IMAGEURL}${product[0].image}`" class="img-responsive book-details-image ">
                </a>
                <img
                  v-else
                  :src="`${IMAGEURL}${product[0].image}`"
                  class="img-responsive book-details-image"
                  alt="Book cover"
                />

                <!-- <div class="img-zoom-container d-sm-none d-md-block" onmousenter="showme(this)">
                  <span>
                    <p class="imgid" style="allign:center;">
                      <img id="myimage" :src="`${IMAGEURL}${product[0].image}`" :srcset="`${IMAGEURL}${product[0].image}`" width="260px">
                    </p>
                  </span>
                  <span id="myhide">
                    <div id="myresult" class="img-zoom-result" onmouseleave="hideme(this)"></div>
                  </span>
                </div> -->

                <!-- <image-zoom :regular="`${IMAGEURL}${product[0].image}`" :zoom="`${IMAGEURL}${product[0].image}`" :zoom-amount="3" img-class="d-none d-sm-block d-md-none" :alt="`${product[0].product_name}`">
                </image-zoom> -->

                <h4 v-if="product[0].award_title" class="details-award-title">
                  {{ product[0].award_title }}
                </h4>
              </div>
              <div v-else>Loading image...</div>
            </div>

            <div class="col-lg-9 col-md-8 col-sm-9">
              <div class="item-details">
                <div class="d-flex justify-content-between flex-column flex-sm-row">
                  <div class="col-12 itemDetails">
                    <div>
                      <h2>{{ product[0].product_name }}</h2>
                    </div>

                    <p>
                      <b>
                        <span v-for="(author, index) in product[0].authors" v-bind:key="index">
                          <a :href="`${baseUrl}author/${author.author_id}`">{{
                              author.author_name
                          }} ({{
                              author.author_name_en
                          }})</a>
                          <span v-if="index + 1 < product[0].authors.length">,
                          </span>
                        </span>
                      </b>
                    </p>
                    <h5 class="book-meta tangon">
                      বিষয় :
                      <a :href="
                        `${baseUrl}category/${product[0].category_id}/newest`
                      ">{{ product[0].category_name }}</a>
                    </h5>
                    <h5 class="book-meta tangon">
                      প্রচ্ছদ : {{ product[0].book_cover_by }}
                    </h5>
                    <h5 class="book-meta tangon">
                      মোট পৃষ্ঠা :
                      <span class="eng-text">{{
                          product[0].number_of_page
                      }}</span>
                    </h5>
                    <h5 class="book-meta">
                      <span class="tangon">প্রকাশের তারিখ :</span>
                      <span class="eng-text">{{
                          product[0].publish_date
                      }}</span>
                    </h5>
                    <h5 class="book-meta">
                      <span class="tangon">কভার টাইপ :</span>
                      <span class="eng-text">{{ product[0].paper_type }}</span>
                    </h5>
                    <h5 class="book-meta eng-text">
                      ISBN : {{ product[0].isbn }}
                    </h5>

                    <div class="mt-2 font-18">
                      <div class="font-weight-bold">
                        <!-- Price:  -->
                          <span v-if="product[0].discount > 0" class="font-weight-bold">
                            <strike>Tk. {{ product[0].orginal_price }}</strike>
                          </span>
                          
                          Tk. {{ product[0].price }}

                          <span v-if="product[0].discount > 0" class="text-success">
                            <span class="ml-2">
                                <label class="font-13">You Save</label> Tk. {{ product[0].orginal_price - product[0].price }}
                              </span>
                            (<span>{{ product[0].discount }}</span>
                            <span v-if="product[0].discount_type == 'Percent'">%</span>
                            <span v-else class="taka-off">Tk.</span>
                            <span class="ml-1">OFF</span>)
                          </span>
                      </div>
                      
                    </div>

                    <div class="my-3 d-flex align-items-center">
                      <button title="Add to Wishlist" class="btn btn-danger btn-sm mr-1" @click="addToWishList(product)">
                        <i class="fa fa-heart"></i>
                      </button>

                      <button v-if="product[0].quantity > 0" class="btn btn-danger btn-sm mr-2" @click="addToCart(product, 2, false, $event)">
                        <i class="fa fa-shopping-cart"></i> 
                        <span title="Add to Cart" v-if="product[0].sale_type === 'Regular'"> Add to Cart</span>
                        <span title="Pre Order" v-else> Pre Order</span>
                      </button>

                      <button title="Buy Now" v-if="product[0].quantity > 0 && product[0].sale_type === 'Regular'" class="btn btn-secondary btn-sm" @click="addToCart(product, 2, true)">
                        <i class="fa fa-shopping-bag"></i> 
                        Order Now
                      </button>

                      <ReprintRequest v-if="product[0].quantity <= 0" :item="product[0]" :icon="true"/>

                      <div class="ml-2">
                        <button title="Share This Book" type="button" class="btn btn-secondary btn-sm share-btn" data-toggle="dropdown" data-display="static" >
                          <i class="fa fa-share-alt"></i> 
                        </button>
                        <div class="dropdown-menu dropdown-menu-lg-right share-btns">
                          <ShareNetwork v-for="network in networks" :network="network.network" :key="network.network" :style="{ backgroundColor: network.color }" :url="sharing.url" :title="sharing.title" :description="sharing.description" :quote="sharing.quote" :hashtags="sharing.hashtags" :twitterUser="sharing.twitterUser">
                            <i :class="network.icon"></i>
                          </ShareNetwork>
                        </div>
                      </div>
                      <div class="share-network-list"></div>
                    </div>
                  </div>

                </div>

                <div class="item-description text-justify" v-html="`${product[0].description}`"></div>
                <div class="item-description text-justify" v-if="product[0].review" v-html="`${product[0].review}`"></div>
                <div class="item-description">
                  <div class="section-header">
                    <h3>মন্তব্য</h3>
                    <div v-if="message.length" :class="`alert alert-${messageType}`">
                      <ul class="m-0 list-unstyled">
                        <li v-for="(item, key) in message" v-bind:key="key">
                          {{ item }}
                        </li>
                      </ul>
                    </div>

                    <form class="mb-2 mt-4" id="comments" @submit="checkForm" action="#" method="post">
                      <div class="form-row">
                        <div class="mb-2">
                          <div class="starrating risingstar d-flex justify-content-center flex-row-reverse">
                            <input type="radio" id="star5" name="rating" v-model="rating" value="5" />
                            <label for="star5" title="5 star"></label>
                            <input type="radio" id="star4" name="rating" v-model="rating" value="4" />
                            <label for="star4" title="4 star"></label>
                            <input type="radio" id="star3" name="rating" v-model="rating" value="3" />
                            <label for="star3" title="3 star"></label>
                            <input type="radio" id="star2" name="rating" v-model="rating" value="2" />
                            <label for="star2" title="2 star"></label>
                            <input type="radio" id="star1" name="rating" v-model="rating" value="1" />
                            <label for="star1" title="1 star"></label>
                          </div>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <label for="inputAddress">Full Name <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" v-model="full_name" id="inputAddress" placeholder="আপনার নাম লিখুন" autocomplete="off" />
                        </div>
                        <div class="form-group col-md-6">
                          <label for="inputMobile">Mobile Number <span class="text-danger">*</span></label>
                          <input type="tel" class="form-control" v-model="mobile" id="inputMobile" maxlength="11" placeholder="01XXXXXXXXX" autocomplete="off" inputmode="numeric" @input="mobile = mobile.replace(/[^0-9]/g, '')" />
                        </div>
                      </div>
                      <div class="">
                        <label for="inputAddress2">Comments <span class="text-danger">*</span></label>
                        <textarea type="text" class="form-control" v-model="comment" id="inputAddress2" placeholder="আপনার মন্তব্য লিখুন" autocomplete="off"></textarea>
                      </div>
                      <div class="row">
                        <div class="col-lg-12 text-right mt-2">
                          <button type="submit" class="btn btn-primary theme-bg">
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>

                    <div class="card comments-box" v-if="comments.length > 0">
                      <div class="card-body">
                        <div class="comment-row" v-for="(commentRow, k) in comments" :key="k">
                          <div class="row">
                            <div class="col-lg-12">
                              <div>
                                <a class="pull-left" href="javascript:;"><strong>{{
                                    commentRow.full_name
                                }}</strong></a>
                                <span class="pull-right writer-name ml-3">
                                  <i v-for="index in commentRow.rating" :key="index" class="fa fa-star text-warning" aria-hidden="true"></i>
                                </span>
                              </div>
                              <div class="text-muted my-2">
                                {{ commentRow.created_at }}
                              </div>
                              <div class="clearfix"></div>
                              <div v-html="commentRow.comment"></div>
                            </div>
                          </div>
                          <div class="card card-inner mt-2" v-if="commentRow.reply">
                            <div class="card-body">
                              <div class="row">
                                <div class="col-lg-12">
                                  <div>
                                    <a href="javascript:;"><strong>কথাপ্রকাশ</strong></a>
                                  </div>
                                  <div v-html="commentRow.reply"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="comments.length >= 10">
                        <button v-if="noOfComments == 'less'" class="pull-right btn btn-sm btn-primary btn-block" @click="seeAllComments">
                          See All
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->

      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="row " v-if="relatedAuthorProducts.length > 1">
            <div class="col-lg-12 ">
              <div class="section-header">
                <h3>এই লেখকের আরও বই</h3>
              </div>
              <div class="section-items ">
                <carousel :autoplay="true" :responsive="{
                  0: { items: 2, nav: false },
                  600: { items: 6, nav: false }
                }" :margin="10">
                  <div v-for="(item, key) in relatedAuthorProducts" v-if="item.id != product[0].id" v-bind:key="key">
                    <ProductCard :item="item" />
                  </div>
                </carousel>
              </div>
            </div>
          </div>

          <div class="row  mt-5" v-if="relatedProducts.length > 1">
            <div class="col-lg-12 ">
              <div class="section-header">
                <h3>এই বিষয়ের আরও বইসমূহ</h3>
              </div>
              <div class="section-items ">
                <carousel :autoplay="true" :responsive="{
                  0: { items: 2, nav: false },
                  600: { items: 7, nav: false }
                }" :margin="10">
                  <div v-for="(item, key) in relatedProducts" v-if="item.id != product[0].id" :key="key">
                    <ProductCard :item="item" />
                  </div>
                </carousel>
              </div>
            </div>
          </div>

          <div class="row  mt-5" v-if="recentViews && recentViews.length > 0">
            <div class="col-lg-12 ">
              <div class="section-header">
                <h3>সম্প্রতি দেখা বইসমূহ</h3>
              </div>
              <div class="section-items ">
                <carousel :autoplay="true" :responsive="{
                  0: { items: 2, nav: false },
                  600: { items: 7, nav: false }
                }" :margin="10">
                  <div v-for="(item, key) in recentViews" class="section-item books" :key="key">
                    <a :href="`${item.url}`">
                      <vue-load-image>
                        <img slot="image" v-bind:src="`${IMAGEURL}${item.json.image}`" alt="Image" class="img-responsive" />
                        <img slot="preloader" v-bind:src="`${baseUrl}/assets/img/loader.gif`" class="small-loader" title="Image Loading..." />
                        <div slot="error">can't load image</div>
                      </vue-load-image>
                      <ProductNameH4 :product_name="item.json.product_name" />
                    </a>
                    <div class="hover-item hover-item-scroll mt-5">
                      <div class="arrow-up"></div>
                      <a :href="`${item.url}`" class="btn btn-black view-details">View Details</a>
                    </div>
                  </div>
                </carousel>
              </div>
            </div>
          </div>
        </div>
      </div>

            <div class="modal" id="pdfModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                      <!-- <div class="modal-header">
              <h5 class="modal-title">একটু পড়ে দেখুন</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div> -->
          <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="modal-body"></div>
          </div>
        </div>
      </div>

      <!-- <div class="modal" id="pdfModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm modal-dialog-centered" role="document" style="max-width: 85%; margin: 1rem auto;">
          <div class="modal-content">
            <div class="modal-header border-0 pb-0">
              <h5 class="modal-title">একটু পড়ে দেখুন</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" style="max-height: 80vh; overflow: hidden; -webkit-overflow-scrolling: touch;"></div>
          </div>
        </div>
      </div> -->
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";
import VueLoadImage from "vue-load-image";
import carousel from "vue-owl-carousel";
import imageZoom from "vue-image-zoomer";
import ReprintRequest from './common/ReprintRequest.vue';
import ProductCard from './common/ProductCard.vue';
import ProductNameH4 from "./common/ProductNameH4.vue";

export default {
  data() {
    return {
      shareTitle: "",
      shareDescription: "",
      shareQuote: "",
      product: [
        {
          product_name: "Loading...",
          description: "Loading...",
          review: "",
          image: ""
        }
      ],
      sharing: {
        url:
          this.baseUrl +
          "/book/" +
          this.$route.params.id +
          "/" +
          this.$route.params.slug,
        //url: 'https://kathafront.bdmarket.xyz/book/15/%E0%A6%86%E0%A6%AE%E0%A6%BE%E0%A6%B0-%E0%A6%AC%E0%A6%BF%E0%A6%B0%E0%A6%B9%E0%A7%87%E0%A6%B0-%E0%A6%89%E0%A6%AA%E0%A6%A8%E0%A7%8D%E0%A6%AF%E0%A6%BE%E0%A6%B8',
        title: this.shareTitle || "",
        description: this.shareDescription,
        quote: this.shareQuote,
        hashtags: "কথাপ্রকাশ",
        twitterUser: ""
      },
      networks: [
        {
          network: "facebook",
          name: "Facebook",
          icon: "fa fa-facebook",
          color: "#1877f2"
        },
        {
          network: "linkedin",
          name: "LinkedIn",
          icon: "fa fa-linkedin",
          color: "#007bb5"
        },
        {
          network: "pinterest",
          name: "Pinterest",
          icon: "fa fa-pinterest",
          color: "#bd081c"
        },
        {
          network: "twitter",
          name: "Twitter",
          icon: "fa fa-twitter",
          color: "#1da1f2"
        },
        {
          network: "whatsapp",
          name: "Whatsapp",
          icon: "fa fa-whatsapp",
          color: "#25d366"
        }
      ],
      relatedProducts: [],
      relatedAuthorProducts: [],
      categoryId: null,
      errors: [],
      comments: [],
      messageType: "danger",
      message: "",
      full_name: null,
      mobile: null,
      comment: null,
      width: "auto",
      noOfComments: "less",
      rating: "5",
      recentViews: []
    };
  },
  components: {
    Layout,
    VueLoadImage,
    carousel,
    imageZoom,
    ReprintRequest,
    ProductCard,
    ProductNameH4
  },
  methods: {
    readPdf(file) {
      if (file) {
        const previewImages = this.product[0].preview_images;
        if (previewImages && previewImages.length > 0) {
          let html = '<div style="overflow-y:auto;max-height:80vh;">';
          previewImages.forEach(p => {
            html += '<img src="' + p.image_url + '" style="width:100%;display:block;margin-bottom:8px;" />';
          });
          html += '</div>';
          $("#pdfModal").modal("show");
          $("#pdfModal .modal-body").html(html);
        } else {
          let html =
            '<embed src="' +
            this.IMAGEURL +
            file +
            '#zoom=85&scrollbar=0&toolbar=0&navpanes=0" width="100%" height="600" alt="Pdf" />';
          $("#pdfModal").modal("show");
          $("#pdfModal .modal-body").html(html);
        }
      }
    },
    getProduct() {
      this.$http
        .get("products-resources/product-details/" + this.$route.params.id)
        .then(response => {
          this.product = response.data.data;
          this.categoryId = this.product[0].category_id;
          this.getRelatedProducts(this.product[0].category_id);
          if(this.product[0].authors[0]) this.getRelatedAuthorProducts(this.product[0].authors[0].author_id);

          this.shareTitle = this.product[0].product_name;
          this.shareDescription = this.product[0].description;

          if (window.fbq) {
            fbq('track', 'ViewContent', {
              content_ids: [this.product[0].id],
              content_name: this.product[0].product_name,
              content_type: 'product',
              value: parseFloat(this.product[0].price) || 0,
              currency: 'BDT'
            });
          }

          //add to recent views
          let url = this.$route.fullPath;
          let data = {
            product_name: this.product[0].product_name,
            image: this.product[0].image
          };
          this.$helper.addToRecentlyViewed("recentViews", url, data, 10);
        })
        .catch(e => {
          this.product = null;
        });
    },
    getRelatedProducts(categoryId) {
      fetch(
        this.APIURL + "products-resources/category/" + categoryId + "/newest"
      )
        .then(response => response.json())
        .then(json => {
          this.relatedProducts = json.data;
          //console.log(json.data)
        });
    },
    getRelatedAuthorProducts(authorId) {
      fetch(this.APIURL + "author-profile/" + authorId)
        .then(response => response.json())
        .then(json => {
          this.relatedAuthorProducts = json.data[0].products;
          //console.log('author data:'+JSON.stringify(json.data[0].products, null, 2))
        });
    },
    getComments() {
      fetch(this.APIURL + "comment-resources/" + this.$route.params.id)
        .then(response => response.json())
        .then(json => {
          this.comments = json.data;

          //console.log('comments:'+JSON.stringify(json.data, null, 2))
        });
    },
    seeAllComments() {
      fetch(this.APIURL + "comment-resources/" + this.$route.params.id + "/all")
        .then(response => response.json())
        .then(json => {
          this.comments = json.data;
          this.noOfComments = "more";
          //console.log('comments:'+JSON.stringify(json.data, null, 2))
        });
    },
    checkForm: function (e) {
      e.preventDefault();

      this.message = [];

      const isValidBdMobile = /^01[3-9]\d{8}$/.test(this.mobile);

      if (this.full_name && this.comment && isValidBdMobile) {
        let formData = new FormData();
        formData.append("rating", this.rating);
        formData.append("full_name", this.full_name);
        formData.append("mobile", this.mobile);
        formData.append("comment", this.comment);
        formData.append("product_id", this.product[0].id);

        fetch(this.APIURL + "comment-resources", {
          method: "POST",
          body: formData
        })
          .then(response => response.json())
          .then(json => {
            //  console.log(json);
            this.messageType = "success";
            this.message.push(
              "Your comment has been added successfully and waiting for approval."
            );
            this.full_name = "";
            this.mobile = "";
            this.comment = "";
            this.getComments();
          });
        return;
      }

      this.messageType = "danger";
      this.message = [];
      if (!this.full_name) {
        this.message.push("Name required.");
      }
      if (!this.mobile) {
        this.message.push("Mobile number required.");
      } else if (!isValidBdMobile) {
        this.message.push("Please enter a valid 11-digit Bangladeshi mobile number (e.g. 01XXXXXXXXX).");
      }
      if (!this.comment) {
        this.message.push("Comment required.");
      }
    },
    addToCart(row, type, redirectToCart = false, e = null) {
      if (type == 2) {
        row = row[0];
      }
      // Pick the currently visible product image to fly from.
      let sourceImg = null;
      if (!redirectToCart) {
        const imgs = document.querySelectorAll(".book-details-image, #myimage");
        for (let i = 0; i < imgs.length; i++) {
          if (imgs[i].offsetWidth > 0) {
            sourceImg = imgs[i];
            break;
          }
        }
      }
      this.$http.post("cart/add", {
        session_id: localStorage.getItem("session_id"),
        product_id: row.id,
        sale_type: row.sale_type,
        user_id: localStorage.getItem("user_id")
      }).then(response => {
        if (response.data.status) {
          if (window.fbq) {
            fbq('track', 'AddToCart', {
              content_ids: [row.id],
              content_name: row.product_name,
              content_type: 'product',
              value: parseFloat(row.price) || 0,
              currency: 'BDT'
            });
          }
          $(".cart-count").text(response.data.cart_count);
          localStorage.setItem("cartCount", response.data.cart_count);
          window.dispatchEvent(new Event("cart-updated"));
          if (redirectToCart) {
            this.$router.push("/cart");
          } else {
            this.$flyToCart(sourceImg);
            this.flashMessage.success({ message: response.data.message });
          }
        } else {
          this.flashMessage.error({ message: response.data.message });
        }
      }).catch(() => {
        this.flashMessage.error({ message: "একটি ত্রুটি ঘটেছে" });
      });
    },
    addToWishList(row) {
      if (
        !localStorage.getItem("token") ||
        localStorage.getItem("token") == "undefined"
      ) {
        localStorage.setItem("redirectUrl", "book/" + row[0].id);
        location.href = "/login";
      }

      let formData = {
        product_id: row[0].id
      };

      this.$authHttp
        .post("wish-list-store", formData)
        .then(response => {
          if (response.data.status) {
            this.flashMessage.success({
              message: "Added to wishlist successfully."
            });
          } else {
            this.flashMessage.error({
              message: response.data.message
            });
          }
        })
        .catch(e => {
          //console.log(e);
        });
    },
    getCssClass(description){
      let descriptionAfterRemovedTags = description.replace( /(<([^>]+)>)/ig, '');
      return /^[a-z0-9]*$/i.test(descriptionAfterRemovedTags[0]) === true?'arial':'tangon';
    }
  },
  mounted() {
    this.getProduct();
    this.getComments();
    this.recentViews = JSON.parse(localStorage.getItem("recentViews"));
    //console.log(this.baseUrl);
  },
  watch: {
    $route(to, from) {
      this.show = false;
    }
  }
};
</script>
